import { Box, Heading, useDisclosure } from '@chakra-ui/react';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import AddButton from '../../../components/Generic/Buttons/AddButton';
import MainContent from '../../../components/Generic/MainContent';
import CoupomList from '../components/CoupomList';
import CreateCoupomModal from '../components/CreateModal';
import {
  CreateListContext,
  ListContextDefaultValue,
  ListContextValue,
} from '../context/ListContext';

const CreateCoupom: FC = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { t } = useTranslation();
  return (
    <>
      <AddButton onClick={onOpen}>{t('addCoupon')}</AddButton>
      <CreateCoupomModal isOpen={isOpen} onClose={onClose} />
    </>
  );
};

const Main: FC = () => {
  const updateList = useState<ListContextValue>(ListContextDefaultValue);
  const { t } = useTranslation();
  return (
    <>
      <Heading mb="48px" color="#469BFF" fontFamily="Poppins">
        {t('coupon')}
      </Heading>
      <Box bg="whiteAlpha.700" p="6" rounded="lg" boxShadow="md">
        <CreateListContext.Provider value={updateList}>
          <CreateCoupom />
          <CoupomList />
        </CreateListContext.Provider>
      </Box>
    </>
  );
};

export const CouponsPage: FC = () => {
  return (
    <MainContent>
      <Main />
    </MainContent>
  );
};
